<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout search-area">
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title"><md-icon>search</md-icon>검색 조건</h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <colgroup>
              <col width="10%" />
              <col width="10%" />
              <col width="1%" />
              <col width="10%" />
              <col width="*" />
            </colgroup>
            <tr>
              <th>대상학기</th>
              <td style="border-right: none;">
                <select v-model="semesterCdFrom" name="semesterCd">
                  <option value="">선택</option>
                  <option
                    v-for="item in semesterCdList"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>
              <td
                style="border-left: none; border-right: none; text-align: center"
              >
                ~
              </td>
              <td style="border-left: none;">
                <select v-model="semesterCdTo" name="semesterCd">
                  <option value="">선택</option>
                  <option
                    v-for="item in semesterCdList"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>
              <md-button
                class="md-info md-sm"
                @click="getDashbordInfo"
                style="margin-left: 5px;"
              >
                <md-icon>check</md-icon>검색
              </md-button>
              <!--              <td colspan="3" style="visibility: hidden; border:none;"/>-->
            </tr>
          </table>
        </md-card-content>
      </md-card>
      <md-card>
          <md-card-header
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <h4 class="title" style="margin: 0; display: flex; align-items: center;">
              <md-icon>list</md-icon>
              검색 결과
            </h4>
            <md-button class="md-info md-sm" style="float: right; margin-bottom: 10px;" @click="downloadExcel">
              <md-icon>file_download</md-icon>엑셀 다운로드
            </md-button>
          </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <colgroup>
              <col width="*" />
              <col width="6%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="5%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
              <col width="6%" />
            </colgroup>
            <tr>
              <th rowspan="4">구분</th>
              <th colspan="14">개인명의</th>
              <th colspan="2">교우자녀</th>
              <th colspan="2">교우회(장학)</th>
            </tr>
            <tr>
              <th rowspan="3">지급교우</th>
              <th colspan="8">지급인원</th>
              <th colspan="5">지급금액</th>
              <th rowspan="3">지급인원</th>
              <th rowspan="3">지급금액</th>
              <th rowspan="3">지급인원</th>
              <th rowspan="3">지급금액</th>
            </tr>
            <tr>
              <th colspan="3">성별</th>
              <th colspan="2">학부</th>
              <th colspan="2">캠퍼스</th>
              <th rowspan="2">합계</th>
              <th colspan="2">학부</th>
              <th colspan="2">캠퍼스</th>
              <th rowspan="2">합계</th>
            </tr>
            <tr>
              <th>남</th>
              <th>여</th>
              <th>미상</th>
              <th>학부</th>
              <th>대학원</th>
              <th>서울</th>
              <th>세종</th>
              <th>학부</th>
              <th>대학원</th>
              <th>서울</th>
              <th>세종</th>
            </tr>
            <tr v-for="(item, index) in (schaInfoList || [])" :key="index" :style="index === schaInfoList.length - 1 ? { fontWeight: 'bold' } : {}">
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.semesterCd }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1Mem }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1ApplyMale }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1ApplyFemale }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1ApplyUnknown }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1ApplyN }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1ApplyY }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1Apply0001 }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1Apply0002 }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb1Apply }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb1AmountN) }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb1AmountY) }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb1Amount0001) }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb1Amount0002) }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb1Amount) }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb2Apply }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb2Amount) }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ item.gb3Apply }}</td>
              <td :style="index === schaInfoList.length - 1 ? { textAlign: 'right', backgroundColor: '#d3efd6' } : { textAlign: 'right' }">{{ getCurrency(item.gb3Amount) }}</td>
            </tr>
          </table>
        </md-card-content>
      </md-card>
      <md-card v-if="summaryRow">
        <md-card-content>
          <div class="summary-block">
            <div class="summary-item">
              <span class="summary-label">지급교우</span>
              <span class="summary-value">{{ getCurrency(totalMem) }}명</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">총 지급인원</span>
              <span class="summary-value">{{ getCurrency(totalApply) }}명</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">총 지급금액</span>
              <span class="summary-value">{{ getCurrency(totalAmount) }}원</span>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "ScholarshipDashboard",

  components: {},

  created() {
    this.getSemesterCdList();
  },

  computed: {
    summaryRow() {
      if (!this.schaInfoList || this.schaInfoList.length === 0) return null;
      return this.schaInfoList[this.schaInfoList.length - 1];
    },
    totalApply() {
      if (!this.summaryRow) return 0;
      return (Number(this.summaryRow.gb1Apply) || 0) + (Number(this.summaryRow.gb2Apply) || 0) + (Number(this.summaryRow.gb3Apply) || 0);
    },
    totalAmount() {
      if (!this.summaryRow) return 0;
      return (Number(this.summaryRow.gb1Amount) || 0) + (Number(this.summaryRow.gb2Amount) || 0) + (Number(this.summaryRow.gb3Amount) || 0);
    },
    totalMem() {
      if (!this.summaryRow) return 0;
      return Number(this.summaryRow.gb1Mem) || 0;
    }
  },

  data() {
    return {
      semesterCdList: [],
      schaInfoList: null,
      semesterCdFrom: null,
      semesterCdTo: null
    };
  },

  methods: {
        decodeBase64(value) {
      return atob(value);
    },

    
    
    
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
        this.semesterCdFrom = this.semesterCdList[0]?.code;
        this.semesterCdTo = this.semesterCdList[0]?.code;
        this.getDashbordInfo();
      });
    },

    getDashbordInfo() {
      let modalOptions = null;
      if (this.semesterCdFrom > this.semesterCdTo) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "대상학기를 정확히 선택해 주세요."
        });
        Swal.fire(modalOptions);
        return false;
      }

      kuaaApi.sendServer(
        URL_CONST.GET_DASHBOARD_SCHA_INFO,
        {
          semesterCdFrom: this.semesterCdFrom,
          semesterCdTo: this.semesterCdTo
        },
        "post",
        response => {
          if (response.data.result) {
  this.schaInfoList = response.data.data.schaInfo;
          } else {
            kuaaFnc.showSwal(
              "Dashboard data error",
              response.data.resultMessage
            );
          }
        }
      );
    },

    /**
     * 숫자 세 자리마다 콤마 추가
     * @param num
     * @returns {string}
     */
    getCurrency(num) {
      return num
        ? num.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,")
        : 0;
    },

    downloadExcel() {
      if (!this.schaInfoList || this.schaInfoList.length === 0) {
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드할 데이터가 없습니다.");
        return;
      }
      // 1. 헤더 정의 (웹 테이블과 동일하게 4행)
      const header1 = [
        ["구분", "개인명의", "", "", "", "", "", "", "", "", "", "", "", "", "", "교우자녀", "", "교우회(장학)", ""]
      ];
      const header2 = [
        ["학기", "지급교우", "남", "여", "미상", "학부(인원)", "대학원(인원)", "서울(인원)", "세종(인원)", "합계(인원)", "학부(금액)", "대학원(금액)", "서울(금액)", "세종(금액)", "합계(금액)", "인원", "금액", "인원", "금액"]
      ];
      // 2. 데이터 변환
      const data = this.schaInfoList.map(item => [
        item.semesterCd,
        item.gb1Mem,
        item.gb1ApplyMale,
        item.gb1ApplyFemale,
        item.gb1ApplyUnknown,
        item.gb1ApplyN,
        item.gb1ApplyY,
        item.gb1Apply0001,
        item.gb1Apply0002,
        item.gb1Apply,
        item.gb1AmountN,
        item.gb1AmountY,
        item.gb1Amount0001,
        item.gb1Amount0002,
        item.gb1Amount,
        item.gb2Apply,
        item.gb2Amount,
        item.gb3Apply,
        item.gb3Amount
      ]);
      // 3. aoa_to_sheet로 시트 생성
      const ws = XLSX.utils.aoa_to_sheet([...header1, ...header2, ...data]);
      // 4. 병합 정보 추가 (웹과 동일하게)
      ws['!merges'] = [
        // 1행 병합
        { s: { r:0, c:1 }, e: { r:0, c:14 } }, // 개인명의
        { s: { r:0, c:15 }, e: { r:0, c:16 } }, // 교우자녀
        { s: { r:0, c:17 }, e: { r:0, c:18 } }, // 교우회(장학)
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dashboard");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fileName = `장학대시보드_${this.semesterCdFrom || ''}_${this.semesterCdTo || ''}.xlsx`;
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
    }
  }
};
</script>

<style scoped>
.summary-block {
  display: flex;
  justify-content: center;
  gap: 60px;
  padding: 20px 0;
}
.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #d3efd6;
  border-radius: 8px;
  padding: 20px 40px;
  min-width: 200px;
}
.summary-label {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
}
.summary-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
</style>
